export default {
  common: {
    header: {
      title: "开启你的无忧奢华之旅"
    },
    hour: "Hour",
    hours: "Hours",
    order: "Orders"
  }
};
